import { Injectable } from '@angular/core';
import { DivisionRole, OrganizationLink } from './security.dto';

@Injectable()
export abstract class UserRolesProviderService {
  abstract roles(): Promise<string[]>;
  abstract hasRole(role: string): Promise<boolean>;
  abstract divisions(): Promise<DivisionRole[]>;
  abstract administrating(): OrganizationLink[];
}
